
import axios from "axios";
import { useState } from "react";
import { baseUrl } from "../../shared/baseUrl";
import swal from 'sweetalert';
import { ProgressBar } from "react-bootstrap";

const ReplaceIDCard = ({ id, setResetID }: any) => {

	const [fileName, setFileName] = useState('');
	const [progress, setProgress] = useState(0)


	const handleChange = (event) => {
		const selectedFile = event.target.files[0];
		if (selectedFile && selectedFile.type === "application/pdf") {
			// setFile(selectedFile);
			setFileName(selectedFile.name);
			setProgress(0); // Reset progress when a new file is selected
			handleSubmit(selectedFile);
		} else {
			// setFile(null);
			setFileName('');
			swal("Invalid file type", "Please select a PDF file", "error");
		}
	};



	const handleSubmit = (selectedFile) => {

		if (!selectedFile) {
			swal("No file selected", "Please select a file to upload", "error");
			return;
		}

		const url = `${baseUrl}/api/v1/application/replace-verification/${id}`;
		const formData = new FormData();
		formData.append('file', selectedFile);
		formData.append('fileName', selectedFile.name);

		const config = {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
			onUploadProgress: (data: { loaded: number; total: number; }) => {
				setProgress(Math.round((100 * data.loaded) / data.total));
			},
		};

		axios.put(url, formData, config).then((response) => {
			if (response.data.message === "success") {
				setResetID(true);
				swal("Resume Uploaded Successfully", "", "success");
				setTimeout(() => {
					setResetID(false);
				}, 2000);
			} else {
				swal("Resume Upload Failed", "", "error");
			}
		}).catch((error) => {
			console.error(error);
			swal("An error occurred", `${error.response.data.message}`, "error");
		});
	};





	return (
		<div className='page'>
			<div className="fileupload-view">
				<div className="row justify-content-center m-0">
					<div className="col-md-6-main">
						<div className="card  ">
							<div className="card-body">
								<div className="kb-data-box">
									<form >
										<div className="kb-file-upload">
											<div className="file-upload-box">
												<input
													type="file"
													id="fileupload"
													accept="application/pdf,image/*"
													className="file-upload-input"
													onChange={handleChange}
												/>
												<span>
													Drag and drop or
													<span className="file-link">Choose your files</span>
												</span>
											</div>
											<ProgressBar animated className="upload-progress-bar" now={progress} />
										</div>
										<div className="kb-attach-box ">
											{fileName && <p>Selected file: {fileName}</p>}
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default ReplaceIDCard
